export default {
  title: 'Marcas',
  form: {
    name: {
      placeholder: 'Pesquisar marca...',
    },
  },
  fields: {
    id: '#',
    name: 'Nome',
    address: 'Morada',
    subdomain: 'Subdomínio',
    shop_url: 'URL da loja',
    companies: 'Empresas',
    slug: 'Slug',
    actions: '',
  },
  empty_list: 'Ainda sem marcas',
  modals: {
    delete_franchise: {
      title: 'Tem a certeza de que pretende eliminar a marca {{name}}?',
    },
  },
  buttons: {
    new_franchise: '+ Adicionar marca',
    export_restaurants: 'Exportar Restaurantes',
    edit: 'Editar',
    delete: 'Eliminar',
    view_dashboard_as_owner: 'Ver painel como proprietário',
    open_shop: 'Abrir loja',
  },
  toasts: {
    failed_to_load_data: 'Erro ao carregar dados',
    failed_to_delete_franchise: 'Falha ao eliminar a marca',
    franchise_got_deleted: 'Marca eliminada',
    failed_to_create_magic_link: 'Erro ao criar magic link',
    no_owner_to_log_in_as: 'Nenhum proprietário de restaurante com quem iniciar sessão',
  },
};
